import axios from 'axios'

export function readFile (fileRequest) {
  return axios.post(`/read-file`, fileRequest,{
    responseType: "blob"
  })
}
